<template>
  <ion-page>
    <ion-content>
      <ion-grid>
        <ion-row class="ion-text-center ion-align-items-center min_full_height">
          <ion-col size="7">
            {{ $t("voice_test.message") }}
          </ion-col>
          <ion-col size="5">
            <ion-row>
              <ion-col>
                <img :src="steps[currentStep].img" class="test-image" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <span :style="{ color: messageColor }" v-html="mostProbableMessage"></span>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <record-audio
                  :helpText="false"
                  @audioRecorded="audioRecorded($event)"
                ></record-audio>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import { IonComponentsMixin } from "@/mixins/IonComponentsMixin";
import { later } from "@/services/Helper";
import RecordAudio from "@/components/RecordAudio";
import { t } from "@/i18n";
import { controller } from "@/services/Controller";


export default defineComponent({
  name: "VoiceTestView",
  components: {
    RecordAudio,
  },
  mixins: [IonComponentsMixin],
  data() {
    return {
      steps: [
        { answer: "voice_test.chair", img: "/assets/img/others/chair.jpg" },
        { answer: "voice_test.banana", img: "/assets/img/others/banana.jpg" },
        {
          answer: "voice_test.elephant",
          img: "/assets/img/others/elephant.png",
        },
      ],
      currentStep: 0,
      mostProbableMessage: "&nbsp;",
      messageColor: "black",
    };
  },
  ionViewDidEnter: async function() {
    controller.logEvent("voice_test_view_entered");
  },
  methods: {
    next: async function () {
      this.$router.replace("/exam");
    },
    audioRecorded: async function(messageOptions) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias

      if (messageOptions.length === 0) {
        controller.logEvent("voice_test_audio_empty", {
          step: this.currentStep,
          expected: this.steps[this.currentStep].answer
        });
        return;
      }

      this.mostProbableMessage = t(
        this.steps[this.currentStep].answer
      );

      this.messageColor = "red";
      let isCorrect = false;

      messageOptions.forEach((element) => {
        if (
          element ===
          t(this.steps[this.currentStep].answer)
        ) {
          this.messageColor = "green";
          isCorrect = true;
        }
      });

      controller.logEvent("voice_test_attempt_evaluated", {
        step: this.currentStep,
        expectedWord: this.steps[this.currentStep].answer,
        recognizedOptions: messageOptions,
        success: isCorrect
      });

      await later(3000);

      if (this.currentStep >= this.steps.length - 1) {
        controller.logEvent("voice_test_completed", {
          totalSteps: this.steps.length
        });
        await later(3000);
        this.$router.replace("/exam");
      } else {
        this.messageColor = 'black';
        this.mostProbableMessage = '&nbsp;';
        this.currentStep++;
      }
    },
  },
});
</script>